import { createFileRoute } from '@tanstack/react-router'

import { queryKeys } from '@/api/keys'
import { notificationsApi } from '@/api/notifications'
import { NotificationSettingsForm } from '@/components/notifications/notification-settings-form'

/** Réglages › Notifications : les catégories internes (lot 13). */
export const Route = createFileRoute('/_app/settings/notifications')({
  component: SettingsNotifications,
})

function SettingsNotifications() {
  return (
    <NotificationSettingsForm
      queryKey={queryKeys.notifications.settings}
      fetch={() => notificationsApi.settings()}
      update={(payload) => notificationsApi.updateSettings(payload)}
    />
  )
}
